// import React from "react";
import "./SportOneFooter.scss";

const SportOneFooter = () => {
  return (
    <footer className="sportone-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h2>W18 Sports Universe</h2>
          <p>Train. Transform. Triumph.</p>
        </div>

        <div className="footer-links">
          <div>
            <h4>Academy</h4>
            <ul>
              <li>
                <a href="/aboutus">About Us</a>
              </li>
              <li>
                <a href="/programs">Programs</a>
              </li>
              <li>
                <a href="/profile">My Profile</a>
              </li>
            </ul>
          </div>

          <div>
            <h4>Support</h4>
            <ul>
              <li>
                <a href="/faq">FAQs</a>
              </li>
              <li>
                <a href="/terms">Terms</a>
              </li>
              <li>
                <a href="/privacy">Privacy</a>
              </li>
            </ul>
          </div>

          <div>
            <h4>Connect</h4>
            <ul>
              <li>
                <a href="mailto:info@shuttleproacademy.com">
                  {" "}
                  info@shuttleproacademy.com{" "}
                </a>
              </li>
              <li>
                <a href="tel:+91 8010560065">+91 8010560065 </a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} W18 Sports Universe. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default SportOneFooter;
